import { Input, Space, message, Spin } from "antd";
import { debounce } from "lodash";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useCallback, useEffect, useState } from "react";
import { addEmail, removeEmail } from "../../../api/setting";
import removeIcon from "../../../assets/images/remove.png";
import checkIcon from "../../../assets/images/check.png";
import { fetchEmailByNotificationContent } from "../../../api/notification-content";

const Email = () => {
  const { emails, emailLoading } = useAppSelector(
    (state) => state.notificationContent,
  );

  const dispatch = useAppDispatch();
  const { list } = useAppSelector((state) => state.notificationType);
  const [incidentLevel, setIncidentLevel] = useState<string>("");
  const handleAdd = useCallback(
    debounce(async (email) => {
      if (!email || !incidentLevel) return;
      if (emails.includes(email.trim())) {
        message.error("Email exists!");
        return;
      }
      await dispatch(
        addEmail({
          email,
          incidentLevel,
        }),
      );
      message.success("Add email successfully");
      setValue("");
    }, 200),
    [emails, incidentLevel],
  );
  const [value, setValue] = useState<string>("");

  useEffect(() => {
    if (list.length) {
      setIncidentLevel(list[0].name);
    }
  }, [list]);

  useEffect(() => {
    if (incidentLevel) {
      dispatch(fetchEmailByNotificationContent(incidentLevel));
    }
  }, [dispatch, incidentLevel]);

  const handleRemove = useCallback(
    debounce(async (email) => {
      await dispatch(removeEmail({ email, type: incidentLevel }));
      message.success("Remove email successfully");
    }, 200),
    [incidentLevel],
  );

  return (
    <div className="w-full">
      <div className="w-full flex mb-4">
        {list.map((option, index) => (
          <div
            className={`w-1/2 justify-center flex items-center cursor-pointer text-container text-base py-3 px-5 ${
              incidentLevel === option.name
                ? "bg-primary text-white"
                : "bg-white text-container"
            } ${
              index === 0 ? "rounded-l-3xl" : "rounded-r-3xl"
            } border-container border capitalize`}
            onClick={() => setIncidentLevel(option.name)}>
            {incidentLevel === option.name && (
              <img className="mr-2" src={checkIcon} alt="" />
            )}{" "}
            {option.name}
          </div>
        ))}
      </div>
      <Space.Compact className="w-full">
        <Input
          disabled={emailLoading}
          className="ant-input-large"
          type="email"
          placeholder="Input Email"
          autoComplete="false"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleAdd(value)}
        />
      </Space.Compact>
      {emailLoading ? (
        <div className="m-4 flex items-center justify-center">
          <Spin />
        </div>
      ) : (
        <div
          style={{ maxHeight: "200px", overflowY: "auto" }}
          className="grid grid-cols-1 gap-4 mt-4 px-4 scroller">
          {emails.map((email) => (
            <div key={email} className="flex items-center justify-between">
              <h5 className="text-left text-secondary text-base">{email}</h5>
              <img
                className="cursor-pointer hover:scale-110 transition duration-100"
                src={removeIcon}
                alt="Icon"
                onClick={() => handleRemove(email)}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Email;
